import React from 'react';
import classNames from "classnames";
import FiltersBar from '../../_common/components/FiltersBar';
import {ButtonUploadFile} from '../../_common/components/ButtonUploadFile/ButtonUploadFile';
import {useBankStatementsContext} from '../context/BankStatementsContext';
import {Button} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import styles from './styles.module.scss';

export function BankStatementsFilter() {
  const {handleMatchingInvoices, handleClearRows} = useBankStatementsContext();

  return (
    <FiltersBar
      buttons={[
        <div className={'d-flex align-items-center'}>
          <ButtonUploadFile onFileSelected={handleMatchingInvoices} accept={'.xls,.xlsx'}/>
          <Button
            type="button"
            className={classNames(styles.clearButton, 'btn btn-sm p-0')}
            onClick={handleClearRows}
          >
            <img
              src={toAbsoluteUrl('/media/svg/Cross_white.svg')}
              alt="i" height={24}
            />
          </Button>
        </div>
      ]}
    />
  );
}
